import React from 'react';
import './DataBlocksSection.css';

const DataBlocksSection: React.FC = () => {
  const blocks = [
    {
      badge: 'ДАННЫЕ',
      icon: 'fas fa-database',
      title: 'Данные: собраны и проверены в соответствии с',
      titleHighlight: 'внутренними стандартами',
      features: [
        'Мы придерживаемся жёстких внутренних регламентов при сборе и валидации редких данных.',
        'Каждое значение автоматически анализируется и сравнивается с историческими показателями, чтобы исключить аномалии.',
        'Используем AI-инструменты, позволяющие быстро выявлять «аномалии» и корректировать неточности.',
        'Безопасность и конфиденциальность в приоритете: доступ к данным разграничен, все взаимодействия шифруются.'
      ]
    },
    {
      badge: 'ДЭШБОРДЫ',
      icon: 'fas fa-tachometer-alt',
      title: 'Быстрые визуализации\nи экспертная поддержка',
      titleHighlight: 'визуализации',
      titleHighlight2: 'экспертная поддержка',
      features: [
        'Создание наглядных дашбордов, показывающих ключевые метрики и динамику по выбранным данным.',
        'Консультации от экспертов datacircle — мы поможем интерпретировать цифры и найти точки роста и конкурентных преимуществ.',
        'Возможность поставить задачи встроенному AI-ассистенту, чтобы оперативно сформировать дополнительные отчёты и провести анализ.',
        'Без сложных настроек: все отчёты готовятся за считаные секунды, остаётся лишь принять решение.'
      ]
    },
    {
      badge: 'ПРОГНОЗЫ',
      icon: 'fas fa-chart-line',
      title: 'Прогнозируйте динамику\nи планируйте с уверенностью',
      titleHighlight: 'планируйте с уверенностью',
      features: [
        'Получайте регулярные прогнозы по компенсациям и другим рыночным показателям от нашей команды аналитиков, опирающихся на индустриальный опыт и инструменты AI.',
        'Будьте информированы нашей командой, как будет меняться рынок в ближайшие месяцы, квартал, год, по итогам нашего анализа исторических данных и текущих тенденций.',
        'Получайте прогнозы с целевыми показателями, вовремя корректируйте стратегию и удерживайте ключевые кадры.',
        'Принимайте решения о бюджете и оплате, опираясь на объективную статистику и проверенные данные.'
      ]
    },
    {
      badge: 'СЦЕНАРИИ',
      icon: 'fas fa-random',
      title: 'Моделируйте различные сценарии\nи находите оптимальные решения',
      titleHighlight: 'оптимальные решения',
      features: [
        '«Что, если» анализ: задайте параметры зарплат, бонусов и опционов, а платформа покажет, как это повлияет на бюджет и удержание сотрудников.',
        'Сравнивайте несколько сценариев — от «лучшего» до «худшего» — и оценивайте риски и выгоды каждого шага.',
        'Изменяйте исходные данные на лету: система пересчитает прогнозы и покажет новые результаты мгновенно.',
        'Делайте стратегический выбор на основе реальных цифр, а не догадок, и сохраняйте лидерство на рынке.'
      ]
    },
    {
      badge: 'БЕНЧМАРКИНГ',
      icon: 'fas fa-chart-bar',
      title: 'Изучайте, сравнивайте\nи моделируйте компенсации в удобном интерфейсе',
      titleHighlight: 'Изучайте',
      titleHighlight2: 'сравнивайте',
      titleHighlight3: 'моделируйте',
      features: [
        'Изучайте уровень вознаграждений по должностям, функциональным зонам и регионам — опирайтесь на актуальные рыночные данные.',
        'Настраивайте фильтры под ваши бизнес-задачи: смотрите бенчмарки для нужных отраслей или категорий сотрудников.',
        'AI-подсказки помогут определить, как скорректировать компенсационный пакет для повышения конкурентоспособности.',
        'С datacircle вы всегда видите, как ваша политика оплаты выглядит на фоне рынка — и успеваете реагировать вовремя.'
      ]
    }
  ];

  return (
    <div className="data-blocks-section">
      {blocks.map((block, index) => (
        <div key={index} className="data-block">
          <div className="block-badge">
            <i className={block.icon}></i>
            {block.badge}
          </div>
          <div className="block-content">
            <h2 className="block-title">
              {block.titleHighlight ? (
                <>
                  {block.titleHighlight2 ? (
                    <>
                      {block.titleHighlight3 ? (
                        <>
                          <span className="block-highlight">{block.titleHighlight}</span>, <span className="block-highlight">{block.titleHighlight2}</span>
                          <br />
                          и <span className="block-highlight">{block.titleHighlight3}</span> компенсации в удобном интерфейсе
                        </>
                      ) : (
                        <>
                          Быстрые <span className="block-highlight">{block.titleHighlight}</span>
                          <br />
                          и <span className="block-highlight">{block.titleHighlight2}</span>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {block.title.split('\n')[0]}
                      <br />
                      и <span className="block-highlight">{block.titleHighlight}</span>
                    </>
                  )}
                </>
              ) : (
                block.title.split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    {i < block.title.split('\n').length - 1 && <br />}
                  </React.Fragment>
                ))
              )}
            </h2>
            <div className="block-features">
              {block.features.map((feature, featureIndex) => (
                <div key={featureIndex} className="block-feature">
                  <i className="fas fa-check-circle"></i>
                  <div className="block-feature-text">{feature}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DataBlocksSection; 